import { useEffect, useState } from "react";
import "./patientFullView.css";
import Icons from "../../Assets/Icons";
import { getLocalizedValue } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { openSecureFileUrl } from "../../utils/secureFilePreview";

const PatientPersonalInfo = ({ data }) => {
  const { t, i18n } = useTranslation();
  const [profilePhoto, setProfilePhoto] = useState(Icons.noProfile);

  useEffect(() => {
    const img = data?.profilePhoto || Icons.noProfile;
    setProfilePhoto(img);
  }, [data?.profilePhoto]);

  return (
    <div className="pdl-info">
      <p className="pdl-title">{t("personalInformation")}</p>
      <div className="ppi-layout">
        <div className="ppi-photo-block">
          <img src={profilePhoto || Icons.noProfile} alt="profile" className="ppi-photo" onError={(e) => { e.currentTarget.src = Icons.noProfile; }} />
          <section className="pdl-hn ppi-hn">
            <p className="pdl-hn-title">{t("hnNumber")}</p>
            <p className="pdl-number ppi-hnNum">{data?.hnNumber}</p>
          </section>
        </div>
        <div className="pdl-section-right">
          <section>
            <p className="ppi-name">
              {getLocalizedValue(data?.firstName, i18n.language)} {getLocalizedValue(data?.lastName, i18n.language)}
            </p>
          </section>
          <section className="pdl-phone-dob ppi-dob">
            <div className="pdl-detail">
              <img src={Icons.gender} alt="mail" />
              <span>{t(data?.gender)}</span>
            </div>
            <div className="pdl-detail">
              <img src={Icons.CalenderIcon} alt="calender" />
              <span>{moment(data?.dateOfBirth).format("DD/MM/YYYY")}</span>
            </div>
          </section>
          <section className="pdl-phone-dob ppi-email">
            <div className="pdl-detail">
              <img src={Icons.Call} alt="call" />
              <span>{data?.countryCode + " " + data?.phoneNumber}</span>
            </div>
            {data?.email && (
              <div className="pdl-detail">
                <img src={Icons.SmsIcon} alt="mail" />
                <span>{data?.email}</span>
              </div>
            )}
          </section>
          <section className="pdl-detail">
            <img src={Icons.insurance} alt="mail" />
            <span>{t(data?.insuranceCategory)}</span>
          </section>
        </div>
      </div>
      {data?.quotation?.length > 0 && (
        <section className="ppi-quotation">
          <p className="pdl-hn-title-1">{t("quotationDetails") || "Quotation Details"}</p>
          {data.quotation.map((file, i) => (
            <div key={i} className="quotation-pdf-display" onClick={() => openSecureFileUrl(file.url)}>
              <img src={Icons.PdfRedIcon} className="pdf-icon" alt="PDF" />
              <span className="attachment-name">{file.name}</span>
            </div>
          ))}
        </section>
      )}
    </div>
  );
};

export default PatientPersonalInfo;
